import React, {useContext, useState} from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import AirportLookup from "../../Airports/components/AirportsLookup";
import AirportSelectDialogValidator from "../validators/AirportSelectDialogValidator";
import SystemContext from "../../../SystemContext";
import CompanyUuidLookup from "../../Companies/components/CompanyUuidLookup";
import {CheckboxEditor} from "../../../controls";
import { useTheme } from '@material-ui/core';


const AirportSelectionDialog = (props) => {
  const SystemData = useContext(SystemContext);
  const theme = useTheme();
  const withSupplier = props.withSupplier || false;

  const [airport, setAirport] = useState(null);
  const [company, setCompany] = useState(null);
  const [excludeAcmi, setExcludeAcmi] = useState(true);

  const [validationState, setValidationStatus] = useState({
    error: true,
    errorMessage: "checking",
    field: null
  });

  const handleClose = () => {
    setAirport(null);
    setCompany(null);
    setExcludeAcmi(true);

    if (props.onChange)
      props.onChange(null);
  };

  const handleSave = () => {
    if (props.onChange) {
      if (withSupplier) {
        if (airport && airport.found && company && company.found)
          props.onChange(airport.value, company.value, excludeAcmi);
      } else {
        if (airport && airport.found)
          props.onChange(airport.value, null, excludeAcmi);
        else
          props.onChange(null);
      }
    }
    setAirport(null);
    setCompany(null);
  };


  if (props.open){
    return (
      <div id={"SelectAnAirportDialog"}>
        <Dialog open={props.open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
                disableBackdropClick={true}
        >
          <DialogTitle id="form-dialog-title">
            <div style={{clear: "both", backgroundColor:theme.palette.primary.main, padding:"10px"}}>
              Airport Selection
            </div>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please select the airport to generate a flight schedule for <br/><br/>
            </DialogContentText>
            <div>
              <AirportLookup
                value={airport ? airport.value : ""}
                returnType={"object"}
                onChange={(returnObject)=> {
                  setAirport(returnObject);
                }}
              />
              <div style={{marginTop: 20}}/>
              <CheckboxEditor
                value={excludeAcmi}
                label="Exclude ACMI Aircraft"
                labelPosition={"end"}
                onChange={(value) => {
                  if (value === false)
                    setExcludeAcmi(false)
                  else
                    setExcludeAcmi(true)
                }}
              />
            </div>
            <AirportSelectDialogValidator
              airport={airport}
              onChange={(validation) => {
                setTimeout(()=> {
                  setValidationStatus(validation);
                },1);
              }}
            />
            {props.withSupplier && airport && airport.value && airport.value.length > 2
              ?
                <div>
                  <div style={{ height: 30 }}></div>
                  <DialogContentText>
                    Please select the recipient company at the airport<br/><br/>
                  </DialogContentText>
                  <CompanyUuidLookup
                    companyType={"SUPPLIER"}
                    value={company ? company.value : ""}
                    returnType={"object"}
                    // type="render"
                    atAirport={airport ? airport.value : ""}
                    onChange={(returnObject)=> {
                      setCompany(returnObject);
                    }}
                  />
                  <AirportSelectDialogValidator
                    airport={airport}
                    withSupplier
                    company={company}
                    onChange={(validation) => {
                      setTimeout(()=> {
                        setValidationStatus(validation);
                      },1);
                    }}
                  />
                </div>
              :
                <></>
            }
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">
              Cancel
            </Button>
            <Button onClick={handleSave} disabled={validationState.error || !airport} color="primary">
              Select
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  } else {
    return (<></>);
  }
}

export default AirportSelectionDialog;
